import { CreateReactionMutation, ObjectType, ReactionType } from 'api';

export const createReactionResponse = (reactionType: ReactionType): CreateReactionMutation => ({
  createReaction: {
    object_type: ObjectType.Content,
    created_at: -1,
    object_id: '-1',
    reaction_type: reactionType,
    user_id: '-1',
    // @ts-ignore
    __typename: 'Reaction',
  },
});
